import { useTheme } from '@mui/material';
import styled from '@emotion/styled';

const IconWrapper = styled.button<{ pressColor: string; }>`
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;

  &:active svg rect {
    fill: #7c85b8; // 눌렀을 때 바뀌는 배경색
  }

  &:active svg path {
    fill: #f0f0f0; // 눌렀을 때 아이콘 색
  }
`;

const PlayIcon = ({ width = 40, height = 40 }: { width?: number; height?: number }) => {
  const theme = useTheme();
  return (
    <IconWrapper pressColor={theme.palette.secondary.main}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 54 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_i_274_7284)">
          <rect width="54" height="54" rx="16" fill={theme.palette.primary.main} />
        </g>
        <path
          d="M37.1161 29.0649C37.5038 28.8516 37.8228 28.5325 38.0361 28.1448C38.6571 27.0157 38.2452 25.5969 37.1161 24.9759L20.9578 16.0888C20.6133 15.8993 20.2265 15.8 19.8333 15.8C18.5447 15.8 17.5 16.8447 17.5 18.1333V35.9074C17.5 36.3006 17.5994 36.6874 17.7888 37.0319C18.4099 38.161 19.8287 38.5729 20.9578 37.9519L37.1161 29.0649ZM19.5417 17.6317L36.5963 27.0133L19.5417 36.3942V17.6317Z"
          fill="white"
        />
        <defs>
          <filter
            id="filter0_i_274_7284"
            x="0"
            y="0"
            width="55"
            height="55"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1" dy="1" />
            <feGaussianBlur stdDeviation="3.3" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.912047 0 0 0 0 0.912047 0 0 0 0 0.940267 0 0 0 1 0"
            />
            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_274_7284" />
          </filter>
        </defs>
      </svg>
    </IconWrapper>
  );
};

export default PlayIcon;
